// extracted by mini-css-extract-plugin
module.exports = {"ReportImagesArea":"ReportImagesArea_ReportImagesArea__pi9vt","ReportImageList":"ReportImagesArea_ReportImageList__zpf2T"};